"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTotalCount = exports.SET_TOTAL_COUNT = exports.TOTAL_COUNT = void 0;
exports.TOTAL_COUNT = '[TotalCount]';
exports.SET_TOTAL_COUNT = `${exports.TOTAL_COUNT} SET`;
const setTotalCount = ({ count = 0 }) => ({
    type: exports.SET_TOTAL_COUNT,
    payload: count,
    meta: { feature: exports.TOTAL_COUNT },
});
exports.setTotalCount = setTotalCount;
//# sourceMappingURL=totalCount.js.map